// Adds space for native status bar when running in Capacitor
import { isNative } from '@/utils/platform';

export function StatusBarSpacer() {
  if (!isNative()) return null;
  
  return (
    <div 
      className="w-full bg-card"
      style={{ 
        height: 'env(safe-area-inset-top, 0px)',
        minHeight: 'env(safe-area-inset-top, 0px)',
      }} 
    />
  );
}
